module.exports = __webpack_public_path__ + "img/head.7209419d.png";